module.exports = __webpack_public_path__ + "img/arrow_left.a713691d.svg";